import React from 'react';
import { Grid, Typography } from '@mui/material';
import { sxStyle } from './styles';

function capitalizarPrimeraLetra(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const BookingRoomsList = ({ room }) => {
  return room?.rooms?.map((room, i) => (
    <Grid
      key={`room-detail-${+i}`}
      sx={sxStyle.gridRooms}
      container
      direction="column"
    >
      <Typography sx={sxStyle.rooms}>
        Habitación {i + 1}: -{' '}
        {capitalizarPrimeraLetra(room.description.toLowerCase())}
      </Typography>
    </Grid>
  ));
};

export default BookingRoomsList;
